import { IVasRateInitialState } from "../../../types/master/vasRateInterface";
import { VasRateActionTypes, VasRateActions } from "../../actionTypes/master/vasRateActionTypes";

const initialState: IVasRateInitialState = {
  vasRateList: [],
  vasRateListPageCount: 0,
  vasRateData: {
    id: 0,
    basis_code: "",
    label: "",
    apply_on: "",
    supports_min_amount: false,
    is_active: false,
  },
};

export default function vasRateReducer(state = initialState, action: VasRateActionTypes): IVasRateInitialState {
  switch (action.type) {
    case VasRateActions.SET_VAS_RATE_LIST:
      return {
        ...state,
        vasRateList: action.payload,
      };

    case VasRateActions.SET_VAS_RATE_LIST_PAGE_COUNT:
      return {
        ...state,
        vasRateListPageCount: action.payload,
      };

    case VasRateActions.SET_VAS_RATE_DATA_BY_ID:
      return {
        ...state,
        vasRateData: action.payload,
      };

    default:
      return state;
  }
}
